
import React from 'react';
import {Loader, Dimmer} from 'semantic-ui-react';
import { compose, branch, renderComponent, mapProps, withState } from 'recompose';
import {withStpItems} from '../items/stp-items.helper';

export const withItemSelection = compose(
	withStpItems,
	branch(
		({ ready }) => !ready,
		renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
	),
	mapProps(({ items, match }) => ({
		item: items.find(item => item.item_ID.toString() === match.params.item_id)
	})),
);

export default {
	withItemSelection,
};
